import styled from 'styled-components';
import { IconButton } from '../../../../navigation/buttons/IconButton/index.js';

var StyledIconButton = styled(IconButton).withConfig({
  displayName: "StyledIconButton",
  componentId: "sc-1cvl4gj-0"
})(["padding:0;margin:0;"]);

export { StyledIconButton };
